import { Link } from "react-router-dom"
import "../css/NavBar.css"



function NavBar(){

    return (
        <>
        <div className="navbar">
            <div ><Link to="/" className="navbar-home navbar-component"></Link></div>
            <div><Link to="/Anagrams" className="navbar-anagrams-solo navbar-component"></Link></div>
            <div ><Link to="/AnagramsLobby" className="navbar-anagrams-multiplayer navbar-component"></Link></div>
            <div ><Link to="/ConnectFourLobby" className="navbar-conn4 navbar-component"></Link></div>
            <div ><Link to="/DotsAndBoxesLobby" className="navbar-dotsboxes navbar-component"></Link></div>
            <div ><Link to="/Battleship" className="navbar-battleship navbar-component"></Link></div>

        </div>
    </>)
}

export default NavBar
